import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo';


const Navbar: React.FC = () => {
  return (
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/" style={{textDecoration:"none"}}>
          <Logo />
        </Link>
        
        <div className="nav-links">
          
          <Link to="/data-cleaning" className="nav-link">Data Cleaning</Link>
          <Link to="/preprocessing" className="nav-link">Preprocessing</Link>
          <Link to="/data-augmentation" className="nav-link">Data Augmenting</Link>
          <Link to="/about" className="nav-link">About</Link>
          {/* Additional links will be added as features are implemented */}
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 